<template>
    <div>
        <Header />
        
         <v-dialog persistent content-class="innerExPan" v-model="Loaderdialog"  id="innerExPan" >
        <v-row no-gutters>
          <v-col cols="12" sm="12" style="text-align:center">
            <img  :src="require('@/assets/images/loader.svg')"  />
          </v-col>
        </v-row>
      </v-dialog>

      <v-snackbar Bottom :timeout="timeout" color="green"  v-model="snackbar">
        {{ SnackbarMessege }}
      </v-snackbar> 
      <v-container class="d-flex justify-center align-center fill-height">
      <v-card class="text-center pa-1" >
  <v-card-text>
        <v-row>
          <v-col cols="12">
            <v-img
              :src="require('@/assets/images/print.gif')"
              
              max-height="200"
            ></v-img>
          </v-col>
        </v-row>
        <v-row  style="font-size:13px;padding:10px;">
          <v-col cols="9" style="text-align: left;"><label>{{ItemObject.ItemName}}</label></v-col> 
          <v-col cols="3" style="text-align:right ;">
              <span class="pull-right" style="text-align:right ;">
            <label style="text-align:right ;">&nbsp;&nbsp;{{ItemObject.ItemCode}}<small style="color:red"></small></label></span>
              </v-col>  
        </v-row>
        <v-col cols="12" sm="12" md="12" style="padding-bottom:0px;padding-top:0px;">
          <v-text-field
         
            label="Barcode"
            outlined
            append-icon="mdi-barcode"
            
            autofocus
            v-model="Barcode"
            @change="GetItemByBarcode($event)"
            @click:append="OpenBarcodeReader"
            dense
          ></v-text-field>
          <v-text-field
             v-model="NoOfCopy"
            label="Number of Slips"
            outlined
            type="number"
            ref="count"
            dense
          ></v-text-field>
          
        </v-col>
        <v-col cols="12" style="text-align:center;padding-bottom:0px;padding-top:0px;">
                Print Details
             
      </v-col>
      <v-row>
      <v-col cols="6" class="text-center" style="font-size:0.5em !important;padding-bottom:0px;padding-top:0px;">
       
      <v-switch
  v-model="IsPrintRetailrate"
      label="Retail Rate "
      color="red"
   
       hide-details></v-switch>
      </v-col>
      <v-col cols="6" class="text-right" style="padding-bottom:0px;padding-top:0px;">
        <v-switch
        
   v-model="IsPrintCost"
      label="Cost"
      color="green"
   :input-value="false"
       hide-details
     
    ></v-switch>
     
      </v-col>
      <v-col cols="12" class="text-center">
      
     
        <v-switch
       v-model="IsPrintRetailrateWithTax"
        label="Retail Rate with Tax"
        color="orange"
         :input-value="false"
         hide-details
       
      ></v-switch>
      </v-col>
      </v-row>
      <v-col cols="12" class="text-center">
        <v-btn color="info" @click="Print()">
          <v-icon dark>mdi-printer </v-icon>
        </v-btn>
      </v-col>
      </v-card-text>
      </v-card>
      </v-container>


      
    <v-dialog v-model="BarcodeModal" persistent width="500">
      <v-card>
        <v-card-title
          style="color:rgb(0 99 145);font-size:17px;text-align:center"
          >Scan barcode</v-card-title
        >

        <v-card-text>
          <StreamBarcodeReader
            @decode="a => onDecode(a)"
            @loaded="() => onLoaded()"
          ></StreamBarcodeReader>
        </v-card-text>
        <v-card-actions hidden>
          <v-spacer></v-spacer>
          <v-btn
            small
            @click="BarcodeModal = false"
            style="background-color:#FB8C00;color:#FFF"
          >
            Cancel
          </v-btn>

          <v-btn
            small
            @click="BarcodeModal = false"
            style="background-color:#2E7D32;color:#FFF"
          >
            Ok
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  
    </div>
  </template>
  
  <script>
 import Header from "../Pages/Header.vue";
 import { StreamBarcodeReader } from "vue-barcode-reader";
 import axios from "axios";
  export default {
    components: {
      Header,StreamBarcodeReader
    },
    data() {
      return {
   
          snackbar: false,
    SnackbarMessege: '',
    timeout: 2000,
    ItemObject:{},
    Barcode:"",
    NoOfCopy:1,
    bURL : localStorage.getItem('BaseURL'),
    Printerurl : localStorage.getItem('Printerurl'),
    IsPrintRetailrate:true,
    IsPrintRetailrateWithTax:true,
    IsPrintCost:false,
    PrinterName:localStorage.getItem('Printer'),
    PrinterType :localStorage.getItem('BarcodeType'),
    BarcodeModal:false,
    Loaderdialog:false,
    PriceGroupId :  localStorage.getItem("PriceGroupId")?localStorage.getItem("PriceGroupId"):0,
    
    }
    },
    created() {
     
    },
    mounted() {
      this.Token = localStorage.getItem('Token')
      if (this.Token === "" || this.Token === null || this.Token === undefined ) 
       {
        this.$router.push("login");
       }

         this.IsNativeFlutterApp = localStorage.getItem("IsNativeFlutterApp");
        if (this.IsNativeFlutterApp === "true" || this.IsNativeFlutterApp === true)
        {
          this.IsNativeFlutterApp = true
        }
        else
        {
          this.IsNativeFlutterApp = false
        }
      //this.GetItemByBarcode()
    },
    methods:{
       onDecode(a) {
      console.log("Result Barcode " + a);
      // this.text = a;
      if (a != null || a != "") {
        this.Barcode = a;
        this.GetItemByBarcode(a)
        this.BarcodeModal = false;
        this.moveToNext('quantity');
     }
    },
    GetItemByBarcode(barcode)
    {
        //this.Barcode = localStorage.getItem('barcode')

        axios
          .get(this.bURL + "/api/item/getitembybarcode?barcode=" + barcode )
          .then(
            (response) => {
              this.ItemObject = response.data
              console.log(this.ItemObject)
            },
            (error) => {
              console.log("error" + error);
              this.error = "Something went wrong..!";
            }
          );
    },
    OpenBarcodeReader()
    {
      this.IsCamera = false
          if (this.IsNativeFlutterApp === true) {
            //window.FromJavascriptScanner.postMessage('CamaraLaunchRequist');
            this.OpenBarcodeReaderFlutter()
          } 
          else
          {
             this.BarcodeModal = true
          }
    },
   
    OpenBarcodeReaderFlutter() {
      // Call the Flutter handler to launch the barcode scanner
      window.flutter_inappwebview.callHandler('CamaraLaunchRequist')
        .then((result) => {
          if (result) {
            // Handle the barcode result
            //console.log('Barcode scanned:', result);
            //this.GetItemByBarcode(result)
            this.Barcode = result
            this.GetItemByBarcode(result)
        this.BarcodeModal = false;
        this.moveToNext('quantity');

          } else {
            console.log('Barcode scanning cancelled or failed');
          }
        })
        .catch((error) => {
          console.error('Error launching barcode scanner:', error);
        });
    },
    Print()
    {
      if(this.PrinterName === "" || this.PrinterName === undefined || this.PrinterName === null || this.PrinterName === "null")
      {
        this.SnackbarMessege = "Set Printer"
        this.snackbar = true
        return
      }
      if(this.PrinterType === "" || this.PrinterType === undefined || this.PrinterType === null || this.PrinterType === "null")
      {
        this.SnackbarMessege = "Set Printer Type"
        this.snackbar = true
        return
      }
       // this.Barcode = localStorage.getItem('barcode')
       this.BranchCode = localStorage.getItem('SystemBranch')
        this.encodePrinterName = encodeURIComponent(this.PrinterName);
        this.Loaderdialog = true
        axios
          .get(this.Printerurl + "/api/item/printbarcode?barcode="+this.Barcode+"&slips="+this.NoOfCopy+"&Printer="+this.encodePrinterName+"&barcodetype=" + this.PrinterType+"&ShowRetailRate="+this.IsPrintRetailrate+"&IsRetailRateWithTax="+this.IsPrintRetailrateWithTax+"&ShowCost="+this.IsPrintCost+'&PriceGroupId=' + this.PriceGroupId +'&BranchCode=' +  this.BranchCode)
          .then(
            (response) => {
              console.log(response.data)
              this.Loaderdialog = false
            },
            (error) => {
              console.log("error" + error);
              this.Loaderdialog = false
              this.error = "Something went wrong..!";
            }
          );
    }
    }
  };
  </script>